import { render, staticRenderFns } from "./AwsTenant.vue?vue&type=template&id=eb8e0c6a&"
import script from "./AwsTenant.vue?vue&type=script&lang=js&"
export * from "./AwsTenant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports